module.exports = __webpack_public_path__ + "fonts/inter-full.c52e6d9.woff2";